// extracted by mini-css-extract-plugin
module.exports = {"cards":"order-cards_cards__14mAS"};